import { useTranslation } from 'react-i18next';
import { CustomTextField } from '../../../../../components/CustomTextField';
import CustomModal from '../../../../../components/Modal/CustomModal';
import { CustomSelect } from '../../../../../components/CustomSelect';
import { CustomSwitch } from '../../../../../components/CustomSwitch';
import HandleChange from "../../../../../Helpers/HandleChange";
import {CUSTOM_FIELD_MODEL, FIELD_TYPE, FIELD_TYPES_MODEL} from "../Model/Model";
import {useState} from 'react';

/**
 * @email kpozos@ibl.mx
 * @author Karen Yunuen Pozos Arias
 * @jobTitle Full Stack Developer
 * @component EditCustomFieldModal
 * @description Modal component for editing a custom field. Handles form inputs and updates the field in the list.
 *
 * @param {Object} props.data - The custom field data being edited.
 * @param {function} props.setData - Setter function to update the custom field data.
 * @param {Array} props.list - The list of custom fields.
 * @param {function} props.setList - Setter function to update the list of custom fields.
 * @param {function} props.onHide - Function to close the modal.
 *
 * @returns {JSX.Element} The rendered EditCustomFieldModal component.
 */
const EditCustomFieldModal = (props) => {
    const { data, setData, list, setList, onHide} = props;
    const { t } = useTranslation();
    const [emptyFields, setEmptyFields] = useState(false);
    const {handleChange} = HandleChange({ model: data, setModel: setData });

    const handleUpdate = () => {
        if (!data?.fieldName || data.fieldName.trim() === "") {
            setEmptyFields(true);
            return;
        }
        setEmptyFields(false);
        let aux = [...list];
        setList(aux.map((e) => {
            if(e.id === data?.id ){
                return data;
            }
            return e;
        }));
        setData({...CUSTOM_FIELD_MODEL });
        onHide();
    }

    return (
        <CustomModal
            {...props}
            title={t("edit_custom_field")}
            size='lg'
            onConfirm={() => handleUpdate()}
        >
            <div className='row'>
                <div className='col-12'>
                    <CustomTextField
                        id={'txt_vt_field_name'}
                        name={'fieldName'}
                        value={data?.fieldName}
                        trans={'field_name'}
                        type={'text'}
                        onChange={handleChange}
                        required={true}
                        emptyFields={emptyFields}
                    />
                </div>
                <div className='col-sm-12 col-md-6 col-lg-6 col-xl-6'>
                    <CustomSelect
                        id={'slt_vt_field_type'}
                        name={'fieldType'}
                        value={data?.fieldType}
                        keyName='id'
                        onChange={handleChange}
                        list={FIELD_TYPES_MODEL()}
                        trans={'field_type'}
                        required={true}
                        showNoSelectionOption={false}
                    />
                </div>

                {data.fieldType !== FIELD_TYPE.CHECKBOX.name &&
                    <div className='col-sm-12 col-md-6 col-lg-6 col-xl-6'>
                        <CustomSwitch
                            id="cb_vt_required"
                            checked={data?.isRequired}
                            onChange={(e) =>
                                handleChange({
                                    target: {name: e.target.name, value: !data.isRequired},
                                })
                            }
                            trans={t('required')}
                            name="isRequired"
                        />
                    </div>
                }
            </div>
        </CustomModal>
    );
};

export default EditCustomFieldModal;
